@if (theme) {
  <div class="slider-section {{ theme?.root }}" tabindex="0">
    <div class="max-w-container mx-auto sm:px-v-spacing {{ theme?.container }} relative">
      @if (showTitle) {
        <div class="wysiwyg py-v-spacing mx-auto" [innerHtml]="sliderTitle">
        </div>
      }
      @if (showDescription) {
        <div class="wysiwyg max-w-container mx-auto"
        [innerHtml]="sliderDescription"></div>
      }
      <div [class]="'text-ace-gray-900 slider-container' + (displayAllCardMobile ? ' hidden sm:block' : ' block')">
        <div #swiperEl class="swiper" [ngClass]="{'hide-arrows-desktop': hideArrowsOnDesktop}">
          <div #prevEl class="swiper-button-prev"></div>
          <div #nextEl class="swiper-button-next"></div>
          <div class="swiper-wrapper">
          @for (slide of slides; track slide; let last = $last) {
            <div class="swiper-slide">
              <div [class]="'bg-white text-vis-dark rounded-ace-mode slider-card shadow-card mb-v-spacing mr-v-spacing flex flex-col justify-between h-full ' + (slide.hasBottomContent ? 'pb-12' : '') + (last ? ' last-slide' : '')">
                <div>
                  <div>
                    @if (slide.slideImage && slide.slideImage[0] && slide.slideImage[0].url) {
                      <img
                        class="slider-full-image mx-auto" [src]="slide.slideImage[0].url"
                        [alt]="slide.slideImage[0].altText ? slide.slideImage[0].altText : ''" [height]="160" [width]="160" />
                    }
                  </div>
                  @if (slide.slideContent) {
                    <div class="wysiwyg wysiwyg-slide-card p-v-spacing"
                    [innerHtml]="slide.slideContent"></div>
                  }
                </div>
                @if (slide.slideButtonLabel) {
                  <div class="py-v-spacing px-v-spacing pt-2">
                    <vision-button defaultStyle="primary" [data]="buttonData(slide)"></vision-button>
                  </div>
                }
              </div>
            </div>
          }
          </div>
        </div>
      </div>
      @if (displayAllCardMobile) {
        <div
          [class]="'text-gray-900' + (displayAllCardMobile ? ' block sm:hidden' : ' hidden')" class="flex flex-col mx-v-spacing">
          @for (slide of slides; track slide; let last = $last) {
            <div class="{{ carouselCellClass }} carousel-cell flex"
              [class.mb-v-spacing]="!last">
              <div class="bg-white p-v-spacing rounded shadow-xl w-full">
                <div>
                  @if (slide.slideImage && slide.slideImage[0] && slide.slideImage[0].url) {
                    <img
                      class="slider-full-image mx-auto" [src]="slide.slideImage[0].url"
                      [alt]="slide.slideImage[0].altText ? slide.slideImage[0].altText : ''" [height]="160" [width]="160" />
                  }
                </div>
                @if (slide.slideContent) {
                  <div class="wysiwyg" [innerHtml]="slide.slideContent"></div>
                }
                @if (slide.slideButtonLabel) {
                  <div class="p-v-spacing">
                    <vision-button defaultStyle="primary" [data]="buttonData(slide)"></vision-button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
